import { useQuery } from '@tanstack/react-query';
import { Filters } from '$/repositories/supabaseRepository/SupabaseRepository.ts';
import { filtersToStringArray } from '@/utils/filtersToStringArray.ts';
import type { Itinerary } from '$/models/Itinerary.model.ts';
import itineraryRepository from '@/api/repositories/itineraryRepository/ItineraryRepository.ts';

const useItineraries = (enabled: boolean = true, filters: Filters<Itinerary> | undefined = undefined) => {
  const queryKey = ['itineraries', ...filtersToStringArray(filters)];

  const queryFn = async () => {
    return getAction(filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useItineraries;

async function getAction(filters?: Filters<Itinerary>): Promise<Itinerary[]> {
  const { data, error } = filters
    ? await itineraryRepository.findMany(filters, {
        order: {
          by: 'created_at',
          ascending: false,
        },
      })
    : await itineraryRepository.all({
        order: {
          by: 'created_at',
          ascending: false,
        },
      });

  if (error) throw new Error(error.message);

  return data ?? [];
}
